export const antiMoneyQuestionsDisabled = (
	professionalStatus,
	fundsOrigin,
	userDocumentType,
	antiMoneyQuestionsList,
	antiMoneyQuestionsReponses,
) => {
	return (
		!professionalStatus ||
		!fundsOrigin ||
		(antiMoneyQuestionsList.length > 0 &&
			antiMoneyQuestionsList.some((qu) => {
				return (
					antiMoneyQuestionsReponses?.[qu.id] === undefined &&
					fundsOrigin !== 'OTHER' &&
					(!qu.dependency || qu.dependency(antiMoneyQuestionsReponses)) &&
					(!qu.condition ||
						(qu.conditionValue === 'CIF' && qu.condition(userDocumentType)) ||
						(qu.conditionValue === 'fundsOriginNotSpain' && qu.condition(fundsOrigin)))
				);
			}))
	);
};

export const antiMoneyQuestionsConditions = (
	question,
	fundsOrigin,
	userDocumentType,
	antiMoneyQuestionsReponses,
) =>
	fundsOrigin !== 'OTHER' &&
	(!question.dependency || question.dependency(antiMoneyQuestionsReponses)) &&
	(!question.condition ||
		(question.conditionValue === 'CIF' && question.condition(userDocumentType)) ||
		(question.conditionValue === 'fundsOriginNotSpain' && question.condition(fundsOrigin)));

export const antiMoneyQuestionsList = [
	{
		id: 4,
		description:
			'El tomador (en caso de persona jurídica los titulares reales), o alguno de sus familiares o allegados ¿desarrolla o ha desarrollado en los últimos dos años un cargo de responsabilidad pública en España, en la Unión Europea o en otro país?',
		type: 'BOOLEAN',
		dependencyQuestionNumber: [],
		dependency: undefined,
		condition: undefined,
		conditionDesc: undefined,
		conditionValue: undefined,
		blocksContinue: 'PBC',
		blocksContinueValue: true,
	},
	{
		id: 5,
		description: 'Observaciones',
		type: 'STRING',
		dependencyQuestionNumber: [4],
		dependency: (responses) => {
			return responses[4];
		},
		condition: undefined,
		conditionDesc: undefined,
		conditionValue: undefined,
		blocksContinue: false,
		blocksContinueValue: undefined,
	},
	{
		id: 6,
		description:
			'Si el tomador es persona jurídica, indicar los siguientes datos del titular/es de un porcentaje igual o superior al 25% del capital social de la misma. En caso contrario, indicar aquella(s) persona(s) física(s) que por otros medios ejerza(n) el control, directo o indirecto. De no existir, indicar el/los administrador/es.',
		type: 'BOOLEAN',
		dependencyQuestionNumber: [],
		dependency: undefined,
		condition: (documentType) => {
			return documentType === 'cif';
		},
		conditionDesc: 'Sólo CIF',
		conditionValue: 'CIF',
		blocksContinue: false,
		blocksContinueValue: undefined,
	},
	// Camacho De Gracia, Manel - Allianz - La pregunta número 7 debéis responderla en default a valor N, dado que responder S sería fraude y posible dolo por vuestra parte en la emisión de póliza. Esta pregunta no debe mostrarse al cliente, la respondéis/incluís en la llamada del Web Service y ya está.
	// {
	// 	id: 7,
	// 	description: '¿Has conocido presencialmente al cliente?',
	// 	type: 'BOOLEAN',
	// 	dependencyQuestionNumber: [],
	// 	dependency: undefined,
	// 	condition: undefined,
	// 	conditionDesc: undefined,
	// 	conditionValue: undefined,
	// 	blocksContinue: false,
	// 	blocksContinueValue: undefined,
	// },
	{
		id: 9,
		description: '¿Cuál es el origen de los fondos que hacen frente al pago de la prima?',
		type: 'SELECT',
		selectValues: [
			{ alzvalue: 1, label: 'Loterías' },
			{ alzvalue: 2, label: 'Herencias' },
			{ alzvalue: 3, label: 'Enajenación de inmuebles' },
			{ alzvalue: 4, label: 'Ahorro personal' },
			{ alzvalue: 9, label: 'Otros' },
		],
		dependencyQuestionNumber: [],
		dependency: undefined,
		condition: undefined,
		conditionDesc: undefined,
		conditionValue: undefined,
		blocksContinue: false,
		blocksContinueValue: undefined,
	},
	{
		id: 11,
		description: 'Describe el origen',
		type: 'STRING',
		dependencyQuestionNumber: [9],
		dependency: (responses) => {
			return responses[9] === 9; // 9 = Otros
		},
		condition: undefined,
		conditionDesc: undefined,
		conditionValue: undefined,
		blocksContinue: false,
		blocksContinueValue: undefined,
	},
	{
		id: 14,
		description: '¿Cúal es la razón de la contratación del seguro?',
		type: 'SELECT',
		selectValues: [
			{ alzvalue: 1, label: 'Remuneración en especie' },
			{ alzvalue: 2, label: 'Aportaciones a sistemas de prevención social' },
			{ alzvalue: 3, label: 'Inversión empresarial' },
		],
		dependencyQuestionNumber: [],
		dependency: undefined,
		condition: (documentType) => {
			return documentType === 'cif';
		},
		conditionDesc: 'Sólo CIF',
		conditionValue: 'CIF',
		blocksContinue: false,
		blocksContinueValue: undefined,
	},
];
